export default __webpack_public_path__ + "static/media/tas-calendar-icon.ec180772.svg";